/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_PasteInputs */



/**
* | output |
* | --- |
* | "Paste" |
*
* @param {Context_Menu_PasteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_paste = /** @type {((inputs?: Context_Menu_PasteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_PasteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Coller")
	if (locale === "de") return /** @type {LocalizedString} */ ("Paste")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impasto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pasta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("粘贴")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ペースト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पेस्ट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Colar")
	return /** @type {LocalizedString} */ ("Paste")
});